import React from "react";
import WeatherIcon from "./WeatherIcon"
import "./DailyForecast.css";

export default function DailyForecast(props) {
   function day(){
    let date = new Date(props.data.dt *1000);
    let day = date.getDay();
    let days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]
  
    return days[day];
  }

  return (
  <div>
    <div className= "forecast-day"> {day()}</div>
    <WeatherIcon code={props.data.weather[0].icon} size = {36}/>
    <div>
      <span className="forecast-temp-max">{Math.round(props.data.temp.max)}<span className="unit">℃</span> </span>
      <span className="forecast-temp-min"> {Math.round(props.data.temp.min)}<span className="unit">℃</span> </span>
    </div>
  </div>
  )
}